let API_BASE_URL: string;
if (!process.env.REACT_APP_API_BASE_URL) {
  API_BASE_URL = "https://maija-backoffice.app/v1/backoffice"; // overridden by CI at build
} else {
  API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
}
const APP_VERSION = process.env.REACT_APP_VERSION ?? "Unknown";

// force local api (uncomment for dev): API_BASE_URL = "http://127.0.0.1:5001/v1/backoffice";

export { API_BASE_URL, APP_VERSION };
